export const Attendance = {
  Status: {
    attended: 1, // 수업
    absent: 2, // 결석
    present: 3, // 등원
    left: 4, // 하원
    custom: 5, // 사용자 정의 상태
    late: 6, // 지각
  },
  TeacherStatus: {
    clockIn: 11, // 교사의 출근
    clockOut: 12, // 교사의 퇴근
  },
  NotificationMethod: {
    push: 1,
    alimTalkToNonMember: 2,
    alimTalkToAll: 3,
  },
  AttCodeBase: {
    parentPhone: 1,
    studentPhone: 2,
  },
  Realtime: {
    Status: {
      waiting: 1,
      called: 2,
      attending: 3,
      dismissed: 4, // 수업완료, 가도 좋음
      left: 5, // 하원
    },
    SpecialMark: {
      // special mark는 모두 _로 시작한다.
      adHocTeacher: '_adHocTeacher',
    },
  },

  PossibleNextStatus: {
    /** from “waiting” you can go to */
    waiting: ['called', 'attending'],

    /** from “called” you can go to */
    called: ['waiting', 'called', 'attending'],

    /** from “attending” you can go to */
    attending: ['waiting', 'dismissed'],

    /** from “dismissed” you can go to */
    dismissed: ['waiting'],

    left: [] as string[],
  },
};
